// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';

import { useKioskSpacing } from '@jane/kiosk/hooks';

export const SearchInputContainer = styled.div(() => {
  const { getKioskSpacing, isIpad } = useKioskSpacing();
  return {
    backgroundColor: 'white',
    flexGrow: 1,
    /** @todo share input overrides with other Kiosk inputs */
    input: {
      fontSize: isIpad ? 16 : 22 /** Body variant */,
      height: getKioskSpacing(64, 48) /** Default or Small button heights */,
    },
    zIndex: 2,
  };
});
